import IndexPage, {
  getServerSideProps,
} from 'containers/project-love/web-not-available/web-not-available-container';

export default IndexPage;

export { getServerSideProps };
